import {Component} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lp2-industry-content-modal-warning',
  templateUrl: './industry-content-modal-warning.component.html'
})
export class IndustryContentModalWarningComponent {


  constructor(
    public activeModal: NgbActiveModal,
  ) {}

  close() {
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/industry-content-section/industry-content-modal-warning/industry-content-modal-warning.component.ts